import React, { useState, useEffect } from "react";

export default function DetailsGrid(props) {
    const [customerData, setCustomerData] = useState();

    useEffect(() => {
        if (props.customerData) setCustomerData(props.customerData);
    }, [props]);

    return customerData ? (
        <div className="flex w-full flex-col">
            {customerData.customer.companyname ? (
                <h1 className="pb-10 text-center">{customerData.customer.companyname}</h1>
            ) : null}

            {/* ROW 1 */}
            <div className="mb-4 flex flex-col justify-between md:flex-row">
                <div className="m-0 my-2 w-full md:m-2">
                    <h4 className="text-center">Key Info</h4>
                    <div className="ngShadow mt-1 h-full w-full overflow-hidden rounded-xl p-4">
                        <p>
                            <b>Total ARR: </b>{" "}
                            {customerData.customer.total_arr
                                ? "$" +
                                  customerData.customer.total_arr.toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                  })
                                : "N/A"}
                        </p>
                        <p>
                            <b>Open Balance: </b>{" "}
                            {customerData.customer.balance !== ""
                                ? "$" +
                                  customerData.customer.balance.toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                  })
                                : "N/A"}
                        </p>
                        <p>
                            <b>Overdue Balance: </b>{" "}
                            {customerData.customer.overduebalance !== ""
                                ? "$" +
                                  customerData.customer.overduebalance.toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                  })
                                : "N/A"}
                        </p>
                        <p>
                            <b>Days Overdue: </b>{" "}
                            {customerData.customer.daysoverdue !== ""
                                ? customerData.customer.daysoverdue
                                : "N/A"}
                        </p>
                        <p>
                            <b>Products Count: </b>{" "}
                            {customerData.customer.products_count !== ""
                                ? customerData.customer.products_count
                                : "N/A"}
                        </p>
                    </div>
                </div>

                <div className="m-0 my-2 w-full md:m-2">
                    <h4 className="text-center">NetSuite Data</h4>
                    <div className="ngShadow mt-1 h-full w-full overflow-hidden rounded-xl p-4">
                        <p>
                            <b>Next Renewal: </b>{" "}
                            {customerData.custentity_ng_next_renewaldate__name
                                ? customerData.custentity_ng_next_renewaldate__name
                                : "N/A"}
                        </p>
                        <p>
                            <b>Netsuite ID: </b> {customerData.customer.id}
                        </p>
                        {/* <p>
              <b>Sales Rep: </b>{" "}
              {customerData.salesrep__name
                ? customerData.salesrep__name
                : "N/A"}
            </p> */}
                        <p>
                            <b>Primary Contact: </b>{" "}
                            {customerData.contact__name ? customerData.contact__name : "N/A"}
                        </p>
                    </div>
                </div>

                <div className="m-0 my-2 w-full md:m-2">
                    <h4 className="text-center">Hubspot Data</h4>
                    <div className="ngShadow mt-1 h-full w-full overflow-hidden rounded-xl p-4">
                        <p>
                            <b>Support Level: </b>{" "}
                            {customerData.hubspot.properties.support
                                ? customerData.hubspot.properties.support
                                : "N/A"}
                        </p>
                        <p>
                            <b>Hubspot ID: </b>{" "}
                            {customerData.customer.custentity_cust_hubspotrecordid
                                ? customerData.customer.custentity_cust_hubspotrecordid
                                : "N/A"}
                        </p>
                        <p>
                            <b>Account Manager: </b>{" "}
                            {customerData.hubspot.account_manager__name
                                ? customerData.hubspot.account_manager__name
                                : "N/A"}
                        </p>
                        <p>
                            <b>Account Executive: </b>{" "}
                            {customerData.hubspot.account_executive__name
                                ? customerData.hubspot.account_executive__name
                                : "N/A"}
                        </p>
                        <p>
                            <b>Expansion Rep: </b>{" "}
                            {customerData.hubspot.expansion_rep__name
                                ? customerData.hubspot.expansion_rep__name
                                : "N/A"}
                        </p>
                        <p>
                            <b>Has Open Deal: </b>{" "}
                            {customerData.hubspot.company_has_open_deal_
                                ? customerData.hubspot.company_has_open_deal_ === "true"
                                    ? "Yes"
                                    : "No"
                                : "N/A"}
                        </p>
                        <p>
                            <b>Health Score: </b>{" "}
                            {customerData.hubspot.customer_health_score
                                ? customerData.hubspot.customer_health_score
                                : "N/A"}
                        </p>
                        <p>
                            <b>Indicator Explanation: </b>{" "}
                            {customerData.hubspot.customer_health_indicator_explanation
                                ? customerData.hubspot.customer_health_indicator_explanation
                                : "N/A"}
                        </p>
                    </div>
                </div>
            </div>

            {/* ROW 2 */}
            <div className="my-0 mb-8 flex flex-col justify-between md:mt-8 md:flex-row">
                {/* ADDRESS */}
                <div className="m-0 my-2 w-full md:m-2">
                    <h4 className="text-center">Address</h4>
                    <div className="ngShadow mt-1 h-full w-full overflow-hidden rounded-xl p-4">
                        <p>
                            <b>Billing Address: </b>{" "}
                            {!customerData.customer.billaddr1 &&
                            !customerData.customer.billaddr2 &&
                            !customerData.customer.billcity &&
                            !customerData.customer.billstate &&
                            !customerData.customer.billcountry &&
                            !customerData.customer.billzip ? (
                                <p>No address available...</p>
                            ) : null}
                        </p>

                        <p>
                            {customerData.customer.billaddr1
                                ? customerData.customer.billaddr1
                                : null}
                        </p>
                        <p>
                            {customerData.customer.billaddr2
                                ? customerData.customer.billaddr2
                                : null}
                        </p>
                        <p>
                            {customerData.customer.billcity ? customerData.customer.billcity : null}
                            {customerData.customer.billstate
                                ? ", " + customerData.customer.billstate
                                : null}
                            {customerData.customer.billcountry
                                ? ", " + customerData.customer.billcountry
                                : null}
                        </p>
                        <p>
                            {customerData.customer.billzip ? customerData.customer.billzip : null}
                        </p>
                    </div>
                </div>

                <div className="m-0 my-2 w-full md:m-2">
                    <h4 className="text-center">Other Info</h4>
                    <div className="ngShadow mt-1 h-full w-full overflow-hidden rounded-xl p-4">
                        <p>
                            <b>Employee Count: </b>{" "}
                            {customerData.customer.license_employee_count
                                ? customerData.customer.license_employee_count
                                : 0}
                        </p>
                        <p>
                            <b>Subsidiary Count: </b>{" "}
                            {customerData.customer.license_subsidiary_count
                                ? customerData.customer.license_subsidiary_count
                                : 0}
                        </p>
                        <p>
                            <b>Industry: </b>{" "}
                            {customerData.custentity_esc_industry__name
                                ? customerData.custentity_esc_industry__name
                                : "N/A"}
                        </p>
                    </div>
                </div>

                <div className="m-0 my-2 w-full md:m-2">
                    <h4 className="text-center">Links</h4>
                    <div className="ngShadow mt-1 h-full w-full overflow-hidden rounded-xl p-4 text-center">
                        {!customerData.customer.hubspot_customer_link &&
                        !customerData.customer.netsuite_customer_link ? (
                            <p>No links available.</p>
                        ) : null}

                        {customerData.customer.hubspot_customer_link ? (
                            <p>
                                <a
                                    href={customerData.customer.hubspot_customer_link}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <b>Hubspot Customer Profile</b>
                                </a>
                            </p>
                        ) : null}

                        {customerData.customer.netsuite_customer_link ? (
                            <p>
                                <a
                                    href={customerData.customer.netsuite_customer_link}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <b>NetSuite Customer Record </b>
                                </a>
                            </p>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    ) : null;
}
